import { render, staticRenderFns } from "./DrugLabelPreview.vue?vue&type=template&id=10b3e512&scoped=true&lang=pug&"
import script from "./DrugLabelPreview.vue?vue&type=script&lang=js&"
export * from "./DrugLabelPreview.vue?vue&type=script&lang=js&"
import style0 from "./DrugLabelPreview.vue?vue&type=style&index=0&id=10b3e512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b3e512",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
